import React, { type ReactNode } from "react"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import ImgRub from "./ImgRub"
import ImgHalva from "./ImgHalva"

import * as styles from "./lowerBanner.module.scss"
import scrollToPersonalForm from "../../helpers/scrollToPersonalForm"

type Props = {
  title: ReactNode
  descr: ReactNode
  buttonText?: string
  variant?: string
  orderNum?: string
}

const renderImage = (variant: string | undefined) => {
  switch (variant) {
    case "gethalva":
      return <ImgHalva alt="price" className={styles.img} />
    default:
      return <ImgRub alt="price" className={styles.img} />
  }
}

export const LowerBanner = ({
  title,
  descr,
  buttonText = "Оформить карту",
  variant,
  orderNum,
}: Props) => (
  <section
    id="lowerBanner"
    className={clsx(styles.section, variant && styles[variant])}
    data-exclude={orderNum}
  >
    <Container>
      <div className={styles.wrap}>
        {renderImage(variant)}
        <div className={styles.textBlock}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.descr}>{descr}</div>
          <Button className={styles.btn} onClick={scrollToPersonalForm}>
            {buttonText}
          </Button>
        </div>
      </div>
    </Container>
  </section>
)
